import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { MatIcon } from '@angular/material/icon';

import { Order } from '../order.interface';

@Component({
  selector: 'customer-tracking-timeline',
  imports: [MatIcon],
  templateUrl: './timeline.component.html',
  styleUrls: ['./timeline.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TimelineComponent {
  public order = input.required<Order>();
}
